/**
 * Formatage UI de la clé commerciale Cloud (NXS-XXXX-XXXX-XXXX-XXXX).
 * Aucune persistance : pure transformation de saisie.
 */

const MAX_BODY_CHARS = 16;

/** Retire espaces / tirets et passe en majuscules (collage tolérant). */
export function normalizeLicenseKeyRaw(raw: string): string {
  return raw.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
}

/**
 * Affiche la clé au format NXS-XXXX-XXXX-XXXX-XXXX pendant la saisie.
 * Tolère collage avec espaces ou tirets ; ne mémorise rien.
 * Le préfixe en cours de frappe (N, NX, NXS) est laissé tel quel pour que la frappe manuelle
 * de « NXS- » ne soit pas déformée et que l’effacement reste possible jusqu’au champ vide.
 */
export function formatLicenseKeyDisplay(raw: string): string {
  const alnum = normalizeLicenseKeyRaw(raw);
  if (!alnum) return '';
  if (alnum === 'N' || alnum === 'NX' || alnum === 'NXS') return alnum;
  const withoutPrefix = alnum.startsWith('NXS') ? alnum.slice(3) : alnum;
  const body = withoutPrefix.slice(0, MAX_BODY_CHARS);
  const groups: string[] = [];
  for (let i = 0; i < body.length; i += 4) {
    groups.push(body.slice(i, i + 4));
  }
  return `NXS-${groups.join('-')}`;
}

/** Valeur à envoyer à l’API (sans espaces, majuscules) ; chaîne vide tant qu’aucun caractère de clé n’est saisi. */
export function licenseKeyForSubmit(raw: string): string {
  const display = formatLicenseKeyDisplay(raw);
  return display.startsWith('NXS-') ? display : '';
}

/** Branche majuscules auto + collage tolérant sur un champ clé (pas de stockage). */
export function bindLicenseKeyInput(input: HTMLInputElement): void {
  const sync = (): void => {
    const next = formatLicenseKeyDisplay(input.value);
    if (input.value !== next) {
      const end = next.length;
      input.value = next;
      try {
        input.setSelectionRange(end, end);
      } catch {
        /* input type may not support selection */
      }
    }
  };
  input.addEventListener('input', sync);
  input.addEventListener('paste', () => {
    window.setTimeout(sync, 0);
  });
}
